var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { style: { left: _vm.leftOffset + "px", width: _vm.leftOffset + "px" } },
    _vm._l(_vm.menuData, function(item, index) {
      return _c(
        "li",
        {
          key: _vm.level + "-" + _vm.parentOrder + "-" + index,
          on: {
            mouseover: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              return _vm.onLiMouseover(
                {
                  level: _vm.level,
                  parentOrder: _vm.parentOrder,
                  index: index
                },
                item
              )
            }
          }
        },
        [
          !item.children || !item.children.length
            ? [
                _c("menu-item", { attrs: { title: item.title } }),
                _vm._v(
                  " +" +
                    _vm._s(_vm.level) +
                    " +" +
                    _vm._s(index) +
                    "--" +
                    _vm._s(_vm.parentOrder) +
                    " "
                )
              ]
            : [
                _vm._v(
                  " " +
                    _vm._s(item.title) +
                    "- " +
                    _vm._s(_vm.level) +
                    " " +
                    _vm._s(index) +
                    "--" +
                    _vm._s(_vm.parentOrder) +
                    " "
                ),
                _c("sub-menu", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.deduceShowSubMenu(index),
                      expression: "deduceShowSubMenu(index)"
                    }
                  ],
                  key: _vm.level + "-" + _vm.parentOrder,
                  attrs: {
                    "menu-context": _vm.menuContext,
                    "menu-data": item.children,
                    level: _vm.level + 1,
                    "parent-order": index
                  }
                })
              ]
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }